import { createContext, useContext, useEffect } from 'react'
import i18n from '../i18n'
import { useConfigContextInfo } from './ConfigContext'

const LocaleContext = createContext()

export const useLocale = () => useContext(LocaleContext)

export const LocaleProvider = ({ children }) => {
  const { locale } = useConfigContextInfo()

  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale)
    } else {
      const browserLocale = navigator.language || 'en'
      i18n.changeLanguage(browserLocale)
    }
  }, [locale])

  return <LocaleContext.Provider value={{ locale }}>{children}</LocaleContext.Provider>
}
